import { render } from "./sideBySideLayout.vue?vue&type=template&id=4f410d83&scoped=true"
import script from "./sideBySideLayout.vue?vue&type=script&lang=js"
export * from "./sideBySideLayout.vue?vue&type=script&lang=js"

import "./sideBySideLayout.vue?vue&type=style&index=0&id=4f410d83&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f410d83"]])

export default __exports__